export default {"src":"/_next/static/media/concierge_24.b02e7e7d.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};